import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';

/** @var ApiCall apiCaller */
const apiCaller = getApiInstance();

function initEnvironment() {
    return dispatch => {
        return apiCaller
            .call(api.initEnvironment())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'TICKETSGIT__SET_ASSIGNEEIDS',
                        assigneeIds: data.assigneeIds
                    });
                } else throw 'general.error.token_has_not_been_correctly_returned_by_server';
            })
            .catch(error => {
                Logger.error('dataActions: initEnvironmentTicketsgit - ', error);
                throw error;
            });
    };
}

function disconnectEnvironment() {
    return dispatch => {
        dispatch({
            type: 'RESET_STORE'
        });
    };
}

export { initEnvironment, disconnectEnvironment };



// WEBPACK FOOTER //
// ./environments/ticketsgit/actions.js